import { useEffect, useState } from 'react';

/** window resize를 추적하는 뷰포트 크기. SSR에서는 1×1로 시작한다. */
export const useViewportSize = () => {
  const [viewportSize, setViewportSize] = useState(() => ({
    height: typeof window === 'undefined' ? 1 : window.innerHeight,
    width: typeof window === 'undefined' ? 1 : window.innerWidth,
  }));

  useEffect(() => {
    const updateViewportSize = () => {
      setViewportSize({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    updateViewportSize();
    window.addEventListener('resize', updateViewportSize);

    return () => {
      window.removeEventListener('resize', updateViewportSize);
    };
  }, []);

  return viewportSize;
};
